import React from "react";

const CamOff = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.12 16.0002L15.12 12.0002L6.82 3.72021L4 6.54021L9.46 12.0002H8C6.9 12.0002 6 12.9002 6 14.0002V34.0002C6 35.1002 6.9 36.0002 8 36.0002H32C32.42 36.0002 32.78 35.8402 33.1 35.6402L39.46 42.0002L42.28 39.1802L24.56 21.4602L19.12 16.0002ZM10 32.0002V16.0002H13.46L29.46 32.0002H10ZM30 16.0002V21.2202L42 33.2202V13.0002L34 21.0002V14.0002C34 12.9002 33.1 12.0002 32 12.0002H20.78L24.78 16.0002H30Z"
        fill="#7CD1B8"
      />
    </svg>
  );
};

export default CamOff;
